export const buttonStrikeoutHighContrast = (backgroundColor: string, StrikeoutColor: string) => {
  return `linear-gradient(to right top, ${backgroundColor} 46%, ${StrikeoutColor} 47%, ${StrikeoutColor} 49%, ${backgroundColor} 50%) no-repeat`;
};
